__turbopack_context__.v({
  "bar": "recording-strip-module__yWmjRG__bar",
  "stopBtn": "recording-strip-module__yWmjRG__stopBtn",
  "stopBtnPulse": "recording-strip-module__yWmjRG__stopBtnPulse",
  "strip": "recording-strip-module__yWmjRG__strip",
  "stripPulse": "recording-strip-module__yWmjRG__stripPulse",
  "timer": "recording-strip-module__yWmjRG__timer",
  "wave": "recording-strip-module__yWmjRG__wave",
});
